import image1 from "../../Assets/images/Scroller/cats-eye.jpg";
import image2 from "../../Assets/images/Scroller/colombo-juprana.jpg";
import image3 from "../../Assets/images/Scroller/Black-Marquina-Granite.jpg";
import image4 from "../../Assets/images/Scroller/blue-dunes.jpg";
import image5 from "../../Assets/images/Scroller/blue-flower.jpg";
import image6 from "../../Assets/images/Scroller/crystel-yellow.jpg";
import image7 from "../../Assets/images/Scroller/impirial-red.jpg";
import image8 from "../../Assets/images/Scroller/lakha-red.jpg";
import image9 from "../../Assets/images/Scroller/Monte-Cristo.jpg";
import image10 from "../../Assets/images/Scroller/p-white.jpg";
import image11 from "../../Assets/images/Scroller/tiger-skin.jpg";
import image12 from "../../Assets/images/Scroller/viscon-white.jpg";
import image13 from "../../Assets/images/Scroller/absolute-black.jpg";
import image14 from "../../Assets/images/Scroller/alaska-gold.jpg";
import image15 from "../../Assets/images/Scroller/alaska-white.jpg";
import image16 from "../../Assets/images/Scroller/Ash-Black-Granite.jpg";
import image17 from "../../Assets/images/Scroller/Azul-Nuevo.jpg";
import image18 from "../../Assets/images/Scroller/bicano-antico.jpg";
import image19 from "../../Assets/images/Scroller/ASTORIA.jpg";
import image20 from "../../Assets/images/Scroller/bala-flower.jpg";
import image21 from "../../Assets/images/Scroller/butterfly.jpg";
import image22 from "../../Assets/images/Scroller/Exotic-Red.jpg";
import image23 from "../../Assets/images/Scroller/French-Green.jpg";
import image24 from "../../Assets/images/Scroller/GHIBLEE.jpg";
import image25 from "../../Assets/images/Scroller/GRANITO-IVORY-BROWN.jpg";
import image26 from "../../Assets/images/Scroller/HIMALAYAN-BLUE.jpg";
import image27 from "../../Assets/images/Scroller/jhansi-red.jpg";
import image28 from "../../Assets/images/Scroller/kashmir-gold.jpg";
import image29 from "../../Assets/images/Scroller/Lavender-Blue.jpg";
import image30 from "../../Assets/images/Scroller/madura-gold.jpg";
import image31 from "../../Assets/images/Scroller/merra-white.jpg";
import image32 from "../../Assets/images/Scroller/raymond-blue.jpg";
import image33 from "../../Assets/images/Scroller/rosewood.jpg";
import image34 from "../../Assets/images/Scroller/Rosy-Pink.jpg";
import image35 from "../../Assets/images/Scroller/Topaz-Brown.jpg";
import image36 from "../../Assets/images/Scroller/Arctic-Pearl.jpg";
import image37 from "../../Assets/images/Scroller/PARADISSO-CLASSICO.jpg";
import image38 from "../../Assets/images/Scroller/Crystal-Blue.jpg";
import image39 from "../../Assets/images/Scroller/Panther.Yellow.jpg";
import image40 from "../../Assets/images/Scroller/Cheema-Pink.jpg";
import image41 from "../../Assets/images/Scroller/black-galaxygranbite.jpg";

export const ScrollerData = [
{
    image: image1,
    label: "Cats Eye"
},
{
    image: image2,
    label: "Colombo Juprana"
},
{
    image: image3,
    label: "Black Marquina Granite"
},
{
    image: image4,
    label: "Blue Dunes"
},
{
    image: image5,
    label: "Blue Flower"
},
{
    image: image6,
    label: "Crystel Yellow"
},
{
    image: image7,
    label: "Impirial Red"
},
{
    image: image8,
    label: "Lakha Red"
},
{
    image: image9,
    label: "Monte Cristo"
},
{
    image: image10,
    label: "P-White"
},
{
    image: image11,
    label: "Tiger Skin"
},
{
    image: image12,
    label: "Viscon White"
},
{
    image: image13,
    label: "Absolute Black"
},
{
    image: image14,
    label: "Alaska Gold"
},
{
    image: image15,
    label: "Alaska White"
},
{
    image: image16,
    label: "Ash Black Granite"
},
{
    image: image17,
    label: "Azul Nuevo"
},
{
    image: image18,
    label: "Bicano Antico"
},
{
    image: image19,
    label: "Astoria"
},
{
    image: image20,
    label: "Bala Flower"
},
{
    image: image21,
    label: "Butterfly"
},
{
    image: image22,
    label: "Exotic Red"
},
{
    image: image23,
    label: "French Green"
},
{
    image: image24,
    label: "Ghibli"
},
{
    image: image25,
    label: "Ivory Brown"
},
{
    image: image26,
    label: "Himalayan Blue"
},
{
    image: image27,
    label: "Jhansi Red"
},
{
    image: image28,
    label: "Kashmir Gold"
},
{
    image: image29,
    label: "Lavender Blue"
},
{
    image: image30,
    label: "Madura Gold"
},
{
    image: image31,
    label: "Merra White"
},
{
    image: image32,
    label: "Raymond Blue"
},
{
    image: image33,
    label: "Rosewood"
},
{
    image: image34,
    label: "Rosy Pink"
},
{
    image: image35,
    label: "Topaz Brown"
},
{
    image: image36,
    label: "Arctic Pearl"
},
{
    image: image37,
    label: "Paradisso Classico"
},
{
    image: image38,
    label: "Crystal Blue"
},
{
    image: image39,
    label: "Panther Yellow"
},
{
    image: image40,
    label: "Cheema Pink"
},
{
    image: image41,
    label: "Black Galaxy Granite"
}
]
export default ScrollerData;